webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_radar_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e5e75be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_radar_vue__ = __webpack_require__(104);
function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e5e75be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_radar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e5e75be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_radar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_back_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37520a73_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37520a73"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_back_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37520a73_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rating_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4c4d4bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rating_vue__ = __webpack_require__(129);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rating_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4c4d4bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rating_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app"
});

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home"
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__ = __webpack_require__(3);


var slideshow;

/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'screensaver',

    components: { buttonRadar: __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__["a" /* default */] },

    data: function data() {
        return {
            slides: this.$store.state.product.images[this.$route.params.product].slides
        };
    },


    computed: {

        productTitle: function productTitle() {
            return this.$store.state.product.title;
        },

        productModel: function productModel() {
            return this.$store.state.product.model;
        },

        productPrice: function productPrice() {
            return this.$store.state.product.price;
        },

        productPricePromo: function productPricePromo() {
            return this.$store.state.product.promo;
        }

    },

    mounted: function mounted() {

        var app = document.getElementById("app");
        app.style.backgroundImage = "";

        this.startSlideshow();
    },
    beforeDestroy: function beforeDestroy() {

        //Stop the slideshow when navigate off
        this.stopSlideshow(slideshow);
    },


    methods: {

        // Stop Slideshow
        stopSlideshow: function stopSlideshow(slideshow) {

            // if interval exists
            if (slideshow) {
                // clear it
                clearInterval(slideshow);
            }
        },


        // Start Slideshow
        startSlideshow: function startSlideshow() {

            var vm = this;
            var screensaver = document.getElementById("screensaver");

            var i = 0;

            // Create Slideshow
            slideshow = setInterval(function () {

                // loop for each slide in the store and set it as the Screensaver Background Image
                screensaver.style.backgroundImage = "url(" + vm.slides[i] + ")";

                if (i < vm.slides.length - 1) {
                    i++;
                } else {
                    i = 0;
                }
            }, 6000);
        }
    }

});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'button-radar',

    props: ['to', 'label'],

    methods: {
        onTouchEnd: function onTouchEnd(e) {

            // WHEN TOUCH ENDS LETS SCALE IT UP AGAIN

            e.target.classList.remove('touching');

            __WEBPACK_IMPORTED_MODULE_0_gsap__["d" /* TweenMax */].to(e.target, 0.6, { scale: 1, boxShadow: '0 10px 10px 0 rgba(0,51,141,0.4)', ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* Bounce */].easeOut });

            // AND NAVIGATE TO THE DESIRABLE ROUTE
            this.$router.push(this.to).catch(function (err) {
                if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation to current location')) {
                    console.log(err);
                }
            });

            // SOME ANIMATION ON THE BUTTON LABEL
            document.querySelector(".button-label").classList.add('fadeout');
        },
        onTouchStart: function onTouchStart(e) {

            //WHEN TOUCHING LETS SCALE IT DOWN, [press effect]

            e.target.classList.add('touching');

            __WEBPACK_IMPORTED_MODULE_0_gsap__["d" /* TweenMax */].to(e.target, 0.6, { scale: 0.4, boxShadow: '0 1px 1px 0 rgba(0,51,141,0.4)', ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["c" /* Quad */].easeOut });
        }
    }

});

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'discover',

    components: {

        buttonRadar: __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__["a" /* default */],
        back: __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__["a" /* default */]

    },

    mounted: function mounted() {

        localStorage.setItem('play', true);

        var app = document.getElementById("app");

        setTimeout(function () {

            app.style.backgroundImage = "";
        }, 200);
    }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'back',

  props: ['backTo'],

  methods: {
    onTouchEnd: function onTouchEnd(e) {

      //if there is a specific link we want to back to, use is. Otherwise go back in the history
      if (this.backTo) {

        this.$router.push(this.backTo).catch(function (err) {
          if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation to current location')) {
            console.log(err);
          }
        });
      } else {

        this.$router.go(-1);
      }

      __WEBPACK_IMPORTED_MODULE_0_gsap__["d" /* TweenMax */].to(e.target, 0.6, { scale: 1, opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["c" /* Quad */].easeOut });
    },
    onTouchStart: function onTouchStart(e) {

      __WEBPACK_IMPORTED_MODULE_0_gsap__["d" /* TweenMax */].to(e.target, 0.6, { scale: 0.5, opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["c" /* Quad */].easeOut });
    }
  }

});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_rating_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reviews_index_vue__ = __webpack_require__(130);





/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'details',

  components: {

    reviewsComponent: __WEBPACK_IMPORTED_MODULE_3__reviews_index_vue__["a" /* default */],
    ratingComponent: __WEBPACK_IMPORTED_MODULE_2__shared_rating_vue__["a" /* default */],
    buttonRadar: __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__["a" /* default */],
    back: __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__["a" /* default */]

  },

  data: function data() {
    return {

      // Get the product data
      data: this.$store.state.product,

      promoPrice: null,

      price: null,

      percentage: null,

      priceDiff: null,

      selectedItem: this.$store.state.product.sizes[0],

      showReviews: false,

      productID: this.$route.params.product

    };
  },


  /*
     Lets watch for a new selection and animate the price
   */
  watch: {

    selectedItem: function selectedItem() {

      //re instance vue (this)
      var vm = this;

      var animationFrame;

      /*
         set the current promotion price = the selected item promotion price
       */
      vm.promoPrice = vm.selectedItem.promo;

      /*
         the selected current item price
        (used for animate the difference between this value and the previous value)
         if selected item size has promotion price set it
        otherwise set the selected item normal price
       */
      var newPrice = vm.selectedItem.promo ? vm.selectedItem.promo : vm.selectedItem.price;

      /*
         the selected item old price
        if the selected item has a promo price, use the selected item old price
        otherwise use its original price
       */
      var oldPrice = vm.selectedItem.promo ? vm.selectedItem.price : vm.price;

      /*
         set the current price = selected item price
        can be the old price or the promotion price
        depends of 'oldPrice'
       */
      vm.price = oldPrice;

      function animate(time) {

        TWEEN.update(time);

        animationFrame = requestAnimationFrame(animate);
      }

      new TWEEN.Tween({ tweeningNumber: oldPrice }).easing(TWEEN.Easing.Quadratic.Out).to({ tweeningNumber: newPrice }, 1000).onUpdate(function () {

        /*
           if has promotion price
          update the promo price
         */
        if (vm.promoPrice) {

          vm.promoPrice = this.tweeningNumber.toFixed(0);
        }

        /*
           otherwise
          update the original price
         */
        else {

            vm.price = this.tweeningNumber.toFixed(0);
          }
      }).onComplete(function () {

        //update the discount %
        vm.percentage = vm.calculate(oldPrice, newPrice);

        //update the price difference
        vm.priceDiff = (oldPrice - newPrice).toFixed(2);

        cancelAnimationFrame(animationFrame);
      }).start();

      animationFrame = requestAnimationFrame(animate);
    }
  },

  methods: {

    // Dropdown OnClick Method
    onClick: function onClick(el) {

      el.target.closest(".dropdown").classList.toggle('opened');
    },


    // Dopdown OnSelect item method
    onSelect: function onSelect(i) {

      /*
        As the product sizes are static data in the state
        we can set the current selected item by getting the index of the clicked item in the dropdown
      */
      this.selectedItem = this.$store.state.product.sizes[i];

      // then set the promo price based on the selection
      this.promoPrice = this.selectedItem.promo;
    },


    //CALCULATE PROMOTION
    calculate: function calculate(price, promo) {

      // Calculates the % discount based on Price and Promo Price

      var rest = price - promo;

      var discount = 100 * rest / price;
      console.log('[discount]', discount);
      return discount.toFixed(0);
    },


    /* OnShowReviews Toggle method */
    onShowReviews: function onShowReviews() {

      // Show/hide the reviews panel
      this.showReviews = !this.showReviews;
    }
  },

  computed: {

    // Our reactive item
    reactiveItem: {

      /*
        Getter
        will init reactiveItem with the first mattress size value
      */
      get: function get() {

        // Start by selecting the first item
        return this.$store.state.product.sizes[0];
      },

      /*
         Setter
         allow us to update the reactiveItem values and thus update price and promoPrice
      */
      set: function set(newValue) {

        this.selectedItem = newValue;
      }

    },

    // Get the rating data form the store
    ratingData: function ratingData() {

      return this.$store.state.product.review;
    }
  },

  updated: function updated() {
    var _this = this;

    // Fallback, if price is null means that the the view was loaded before the store being ready
    if (this.promoPrice == null) {

      // var vm = this;

      // Selected item will then be the Computed reactiveItem
      setTimeout(function () {

        _this.selectedItem = _this.reactiveItem;
      }, 500);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // Listen to showReviews event emit from reviews-component, so we know when to close the component
    this.$on('showReviews', function (fromChild) {

      _this2.showReviews = fromChild;
    });

    // INIT VALUES

    // Calculate percentage
    this.percentage = this.calculate(this.reactiveItem.price, this.reactiveItem.promo);

    // Price difference
    this.priceDiff = (this.reactiveItem.price - this.reactiveItem.promo).toFixed(2);
    // Start by getting the first item price
    this.price = this.reactiveItem.price;

    // Start by getting the first item promo price
    this.promoPrice = this.reactiveItem.promo;

    localStorage.setItem('play', true);

    var app = document.getElementById("app");
    app.style.backgroundImage = "";
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'rating-component',

    props: ['product'],

    data: function data() {
        return {

            score: 0

        };
    },


    computed: {
        calculateSize: function calculateSize() {

            return this.score * 70 / 5 + 'px';
        },
        difference: function difference() {

            return 70 - this.score * 70 / 5 + 'px';
        }
    },

    mounted: function mounted() {

        var vm = this;

        var MERCHANT_ID = 877647;

        var LOCALE = "en_US";

        var API_KEY = "7c4da1e0-28bd-4d6a-839e-7bced28cbe1b";

        var PAGE_SIZE = 1;

        if (!this.product) return;

        var product = this.product.toUpperCase();

        switch (product) {
            case 'AS1':
                product = 132;
                break;
            case 'AS2':
                product = 128;
                break;
            case 'AS3':
                product = 130;
                break;
            case 'AS4':
                product = 141;
                break;
            case 'AS5':
                product = 137;
                break;
            default:
                product = '';
        }

        var url = "https://readservices-b2c.powerreviews.com/m/" + MERCHANT_ID + "/l/" + LOCALE + "/product/" + product + "/reviews?paging.size=" + PAGE_SIZE + "&apikey=" + API_KEY + "&format=json";

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (res) {
            return res;
        }).then(function (data) {

            vm.score = data.data.results[0].rollup.average_rating;
        }).catch(function (err) {
            console.error('[ERROR] Unable to load ratings', err);
        });
    }
});

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_rating_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__review_item_vue__ = __webpack_require__(132);




// intersectionObserver pollyfill
__webpack_require__(135);

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'reviews-component',

  props: ['data'],

  components: {

    ratingComponent: __WEBPACK_IMPORTED_MODULE_1__shared_rating_vue__["a" /* default */],
    reviewItem: __WEBPACK_IMPORTED_MODULE_2__review_item_vue__["a" /* default */]

  },

  data: function data() {

    return {

      paging: 0

    };
  },


  computed: {
    reviews: function reviews() {

      return this.$store.state.product.reviews;
    }
  },

  methods: {
    onTouchEnd: function onTouchEnd(e) {

      __WEBPACK_IMPORTED_MODULE_0_gsap__["d" /* TweenMax */].to(e.target, 0.6, { scale: 1, opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["c" /* Quad */].easeOut });

      // tell the parent that close button wats clicked
      this.$parent.$emit('showReviews', false);
    },
    onTouchStart: function onTouchStart(e) {

      __WEBPACK_IMPORTED_MODULE_0_gsap__["d" /* TweenMax */].to(e.target, 0.6, { scale: 0.5, opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["c" /* Quad */].easeOut });
    },
    onIntersectionChange: function onIntersectionChange(changes) {

      /* Google for IntersectionObserver to know more */

      var vm = this;

      var product = this.$route.params.product;

      changes.forEach(function (change) {

        if (change.isIntersecting) {

          vm.paging = vm.paging + 1;

          // Dispatch event to get product reviews by url parameter and save it on the store
          vm.$store.dispatch('get_product_reviews', { product: product, page: vm.paging });
        } else {}
      });
    },
    loadMore: function loadMore() {

      var loader = document.getElementById("loader");

      var scrollRoot = document.getElementById("scroll-root");

      // Intersection observer is supported
      if ('IntersectionObserver' in window) {

        // The observer
        var scrollObserver = new IntersectionObserver(this.onIntersectionChange, {

          root: scrollRoot, // root will be the parent container

          rootMargin: '250px', // fire it when loading element is at 250px from the bottom of the root

          threshold: 0.01

        });

        scrollObserver.observe(loader);
      }
    }
  },

  mounted: function mounted() {

    // Init lazy load
    this.loadMore();
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_rating_vue__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'review-item',

  props: ['data'], // review date coming from parent component

  components: { ratingComponent: __WEBPACK_IMPORTED_MODULE_0__shared_rating_vue__["a" /* default */] },

  computed: {
    calculateSize: function calculateSize() {

      return this.data.metrics.rating * 70 / 5 + 'px';
    },
    difference: function difference() {

      return 70 - this.data.metrics.rating * 70 / 5 + 'px';
    }
  }

});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_rating_vue__ = __webpack_require__(15);




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'details',

  components: {

    ratingComponent: __WEBPACK_IMPORTED_MODULE_2__shared_rating_vue__["a" /* default */],
    buttonRadar: __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__["a" /* default */],
    back: __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__["a" /* default */]

  },

  data: function data() {
    return {

      // Get the product comparison data
      data: this.$store.state.compare

    };
  },
  mounted: function mounted() {

    localStorage.setItem('play', true);

    var app = document.getElementById("app");
    app.style.backgroundImage = "";
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_back_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_button_radar_vue__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'our-technology',

  components: {

    back: __WEBPACK_IMPORTED_MODULE_0__shared_back_vue__["a" /* default */],
    buttonRadar: __WEBPACK_IMPORTED_MODULE_1__shared_button_radar_vue__["a" /* default */]

  },

  data: function data() {
    return {

      videoIsFinished: false,
      from: null,
      autoplay: localStorage.getItem('play')

    };
  },


  methods: {

    // Video doesn't autoplay on Mobile devices, so lets fake a tap
    play: function play() {

      var video = document.getElementById("video");

      setTimeout(function () {

        video.play();
      }, 500);
    }
  },

  mounted: function mounted() {

    var vm = this;
    var app = document.getElementById("app");
    var video = document.getElementById("video");
    var player = document.getElementById("player");

    var p = localStorage.getItem('play');

    if (p == 'false') {

      this.videoIsFinished = true;
      video.currentTime = 3;
      video.pause();

      video.style.zIndex = -1;
      video.style.opacity = 0;
    } else {

      player.click();
    }

    video.addEventListener('ended', function () {

      // Set the APP background image to match the first frame of the videos, so we have a nice transition
      app.style.backgroundImage = "url('/static/media/images/our-technology-background.jpg')";

      video.style.zIndex = -1;
      video.style.opacity = 0;

      vm.videoIsFinished = true;
    });
  },
  destroyed: function destroyed() {

    var video = document.getElementById("video");
    video.currentTime = 0;
    video.pause();
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'panel',

  components: {

    buttonRadar: __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__["a" /* default */],
    back: __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__["a" /* default */]

  },

  data: function data() {
    return {

      showBack: false,
      showRadar: false,
      showPanel: false

    };
  },


  methods: {

    //Video doesnt autoplay on Mobile devices, so lets fake a tap
    play: function play() {

      setTimeout(function () {

        var playVideo = document.getElementById("screensaver-video");
        playVideo.play();
      }, 500);
    }
  },

  mounted: function mounted() {

    localStorage.setItem('play', false);

    var vue = this;

    var video = document.getElementById("screensaver-video");

    var player = document.getElementById("player");

    var e = new Event('touchstart');
    player.dispatchEvent(e);

    setTimeout(function () {

      vue.showPanel = true;

      vue.showRadar = true;

      vue.showBack = true;
    }, 5000);
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'panel',

  components: {

    buttonRadar: __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__["a" /* default */],
    back: __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__["a" /* default */]

  },

  data: function data() {
    return {

      showBack: false,
      showRadar: false,
      showPanel: false

    };
  },


  methods: {

    // Video doesn't autoplay on Mobile devices, so lets fake a tap
    play: function play() {

      setTimeout(function () {

        var playVideo = document.getElementById("screensaver-video");
        playVideo.play();
      }, 500);
    }
  },

  mounted: function mounted() {

    localStorage.setItem('play', false);

    var vue = this;

    var video = document.getElementById("screensaver-video");

    var player = document.getElementById("player");

    var e = new Event('touchstart');
    player.dispatchEvent(e);

    setTimeout(function () {

      vue.showPanel = true;

      vue.showRadar = true;

      vue.showBack = true;
    }, 4000);
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'panel',

  components: {

    buttonRadar: __WEBPACK_IMPORTED_MODULE_0__shared_button_radar_vue__["a" /* default */],
    back: __WEBPACK_IMPORTED_MODULE_1__shared_back_vue__["a" /* default */]

  },

  data: function data() {
    return {

      showBack: false,
      showRadar: false,
      showPanel: false

    };
  },


  methods: {

    //Video doesnt autoplay on Mobile devices, so lets fake a tap
    play: function play() {

      setTimeout(function () {

        var playVideo = document.getElementById("screensaver-video");
        playVideo.play();
      }, 500);
    }
  },

  mounted: function mounted() {

    localStorage.setItem('play', false);

    var vue = this;

    var video = document.getElementById("screensaver-video");

    var player = document.getElementById("player");

    var e = new Event('touchstart');
    player.dispatchEvent(e);

    setTimeout(function () {

      vue.showPanel = true;

      vue.showRadar = true;

      vue.showBack = true;
    }, 5000);
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_store__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_slide_in_directive__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_slide_up_directive__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_pop_in_directive__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__functions_zoom__ = __webpack_require__(167);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







/* DIRECTIVES */




/* FUNCTIONS */


/* config */
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* USE */
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.options.root = 'https://amerisleep-cms.firebaseapp.com';
/* eslint-disable no-new */
var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__vuex_store__["a" /* default */],
  // el: '#app',
  // template: '<App/>',
  // components: { App },
  directives: {
    'slide-in': __WEBPACK_IMPORTED_MODULE_7__directives_slide_in_directive__["a" /* default */],
    'slide-up': __WEBPACK_IMPORTED_MODULE_8__directives_slide_up_directive__["a" /* default */],
    'pop-in': __WEBPACK_IMPORTED_MODULE_9__directives_pop_in_directive__["a" /* default */]
  },

  updated: function updated() {
    Object(__WEBPACK_IMPORTED_MODULE_10__functions_zoom__["a" /* default */])(this);
  },
  mounted: function mounted() {

    // Init Zoom
    Object(__WEBPACK_IMPORTED_MODULE_10__functions_zoom__["a" /* default */])(this);

    // Init ScreenSaver
    this.showScreensaver();

    // The current product eg.: as1
    var product = this.$route.params.product;

    console.log('[product]', product);

    this.createManifest(product);
    // Dispatch event to get product by url parameter and save it on the store
    this.$store.dispatch('get_product_details', product);

    // Dispatch event to get product review average by url parameter and save it on the store
    this.$store.dispatch('get_product_reviews_average', product);

    // Set the ScreenSaver background based on the current product
    var bg = document.getElementById("screensaver");
    if (product) {
      bg.style.backgroundImage = "url(" + this.$store.state.product.images[product].slides[8] + ")";
    } else {
      // bg.style.backgroundImage = 'url(/s)'
    }
  },


  methods: {
    /*
      SCREENSAVER
      show screensaver if inactive
    */
    showScreensaver: function showScreensaver() {

      // The timeout
      var mousetimeout;
      // Sw interval check
      var checkSwInterval = void 0;

      // Lets reinstance 'this' so we ca use within 'document'
      var vue = this;

      // Always clean the timeout as soon as the user touch the screen
      document.addEventListener("touchstart", function (e) {

        clearTimeout(mousetimeout);
        clearInterval(checkSwInterval);
      });

      // Set the timeout as soon as the user finishes touching the screen
      document.addEventListener("touchend", function () {

        mousetimeout = setTimeout(function () {

          // Redirect to home
          vue.$router.push({ name: 'screensaver' });
          vue.forceSWupdate();

          checkSwInterval = setInterval(function () {
            vue.forceSWupdate();
          }, 1000 * 60 * 10); // 10 minutes
        }, 1000 * 60 * 6); // 6 minutes
      });
    },
    forceSWupdate: function forceSWupdate() {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(registrations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var registration = _step.value;

              registration.update();
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        });
      }
    },
    createManifest: function createManifest(product) {
      if (product && navigator.onLine) {
        var link = document.createElement('link');
        link.href = '/static/manifests/' + product.toLowerCase() + '/manifest.json';
        link.rel = 'manifest';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    }
  }
}).$mount('#app');

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(39);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2618fa6f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(92);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2618fa6f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in","name":'fade'}},[_c('router-view',{key:_vm.$route.params.product})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 93 */,
/* 94 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_screensaver_index_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_discover_index_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_details_index_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_compare_index_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_our_technology_index_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_cover_index_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_biopur_index_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_hive_index_vue__ = __webpack_require__(150);











// import Hello from '@/components/Hello'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, { path: '/:product', name: 'screensaver', component: __WEBPACK_IMPORTED_MODULE_3__components_screensaver_index_vue__["a" /* default */] }, { path: '/:product/discover', name: 'discover', component: __WEBPACK_IMPORTED_MODULE_4__components_discover_index_vue__["a" /* default */] }, { path: '/:product/our-technology', name: 'our-technology', component: __WEBPACK_IMPORTED_MODULE_7__components_our_technology_index_vue__["a" /* default */] }, { path: '/:product/details', component: __WEBPACK_IMPORTED_MODULE_5__components_details_index_vue__["a" /* default */] }, { path: '/:product/compare', component: __WEBPACK_IMPORTED_MODULE_6__components_compare_index_vue__["a" /* default */] }, { path: '/:product/our-technology/cover', name: 'cover', component: __WEBPACK_IMPORTED_MODULE_8__components_cover_index_vue__["a" /* default */] }, { path: '/:product/our-technology/biopur', name: 'biopur', component: __WEBPACK_IMPORTED_MODULE_9__components_biopur_index_vue__["a" /* default */] }, { path: '/:product/our-technology/hive', name: 'hive', component: __WEBPACK_IMPORTED_MODULE_10__components_hive_index_vue__["a" /* default */] }]
}));

/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfcec8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(98);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfcec8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_screensaver_component_js__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e54e26e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_screensaver_component_html__ = __webpack_require__(105);
function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e54e26e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_screensaver_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e54e26e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_screensaver_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */,
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discover"},[_c('span',{staticClass:"button-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"button",on:{"touchstart":function($event){return _vm.onTouchStart($event)},"touchend":function($event){return _vm.onTouchEnd($event)},"click":function($event){return _vm.onTouchEnd($event)}}},[_vm._t("default",[_c('img',{attrs:{"src":"/static/media/icons/arrow.svg"}})])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screensaver view"},[_c('transition',{attrs:{"name":'fade'}},[_c('div',{staticClass:"category"},[_c('h1',[_vm._v(_vm._s(_vm.productTitle))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.productModel)+":")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.productPrice))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.productPricePromo))])])]),_vm._v(" "),_c('button-radar',{attrs:{"to":'/' + _vm.$route.params.product + '/discover',"label":'discover'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_discover_component_js__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b047302_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_discover_component_html__ = __webpack_require__(110);
function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b047302"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_discover_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b047302_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_discover_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"back"}},[_c('span',{staticClass:"button-label"},[_vm._v("BACK")]),_vm._v(" "),_c('div',{directives:[{name:"pop-in",rawName:"v-pop-in",value:(800),expression:"800"}],staticClass:"button",on:{"touchstart":function($event){return _vm.onTouchStart($event)},"touchend":function($event){return _vm.onTouchEnd($event)},"click":function($event){return _vm.onTouchEnd($event)}}},[_c('img',{attrs:{"src":"/static/media/icons/arrow.png"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"discover-component view"},[_c('button-radar',{directives:[{name:"pop-in",rawName:"v-pop-in",value:(400),expression:"400"}],attrs:{"to":'/' + _vm.$route.params.product + '/details',"label":'explore ' + _vm.$route.params.product + ' features'}}),_vm._v(" "),_c('button-radar',{directives:[{name:"pop-in",rawName:"v-pop-in",value:(800),expression:"800"}],attrs:{"to":'/' + _vm.$route.params.product + '/our-technology',"label":'our technology'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_details_component_js__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9f23a80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_details_component_html__ = __webpack_require__(137);
function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9f23a80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_details_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9f23a80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_details_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-component"},[_c('div',{staticClass:"stars",style:({width: _vm.calculateSize, marginRight: _vm.difference})}),_vm._v(" "),_c('div',{staticClass:"rating-info"},[_vm._v(_vm._s(_vm.score))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_reviews_component_js__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca665d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_reviews_component_html__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ca665d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_reviews_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca665d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_reviews_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_review_item_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a571828_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_review_item_vue__ = __webpack_require__(134);
function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a571828"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_review_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a571828_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_review_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review-item"},[_c('div',{staticClass:"is-flexy is-middle"},[_c('div',{staticClass:"rating-component"},[_c('div',{staticClass:"stars",style:({width: _vm.calculateSize, marginRight: _vm.difference})}),_vm._v(" "),_c('div',{staticClass:"rating-info",staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.data.metrics.rating)+".0")])]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.data.details.headline))]),_vm._v(" "),_c('span',{staticClass:"by-from"},[_vm._v("By "),_c('span',[_vm._v(_vm._s(_vm.data.details.nickname))]),_vm._v(" from "),_c('span',[_vm._v(_vm._s(_vm.data.details.location))])])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.details.comments))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"reviews-component"},[_c('div',{attrs:{"id":"close"}},[_c('div',{staticClass:"button",on:{"touchstart":function($event){return _vm.onTouchStart($event)},"touchend":function($event){return _vm.onTouchEnd($event)}}},[_c('img',{attrs:{"src":"/static/media/icons/close.png"}})])]),_vm._v(" "),_c('div',{staticClass:"head is-flexy is-middle"},[_c('h2',[_vm._v(_vm._s(_vm.$store.state.product.title))]),_vm._v(" "),_c('rating-component',{attrs:{"product":_vm.$route.params.product}}),_vm._v(" "),_c('span',{staticClass:"based"},[_vm._v("based on "),_c('i',[_vm._v(_vm._s(_vm.data.votes)+" reviews")])])],1),_vm._v(" "),_c('div',{staticClass:"scroll",attrs:{"id":"scroll-root"}},[_vm._l((_vm.reviews),function(item){return _c('review-item',{key:item,attrs:{"data":item}})}),_vm._v(" "),_c('h4',{staticStyle:{"float":"left","width":"100%"},attrs:{"id":"loader"}},[_vm._v("LOADING...")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"details view",class:{ shadow: _vm.showReviews }},[_c('back'),_vm._v(" "),_c('button-radar',{directives:[{name:"pop-in",rawName:"v-pop-in",value:(200),expression:"200"}],attrs:{"to":'/' + _vm.$route.params.product + '/compare',"label":'compare'}}),_vm._v(" "),_c('section',{staticClass:"view-wrapper"},[_c('div',{staticClass:"main-block"},[_c('span',{staticClass:"is-flexy is-bottom"},[_c('h1',[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('span',{staticClass:"hardness"},[_vm._v(_vm._s(_vm.data.hardness))])]),_vm._v(" "),_c('span',{staticClass:"review-block",on:{"click":_vm.onShowReviews}},[_c('rating-component',{attrs:{"product":_vm.productID}}),_vm._v(" "),_c('div',{staticClass:"rating-info"},[_vm._v(" / 5.0 ("+_vm._s(_vm.ratingData.votes)+")")]),_vm._v(" "),_c('div',{staticClass:"read"},[_vm._v("Read Reviews")]),_vm._v(" "),_c('div',{staticClass:"custom-info"},[_vm._v(_vm._s(_vm.ratingData.recommended_ratio)+" would recommend this to a friend")])],1),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.description)}})]),_vm._v(" "),_c('div',{staticClass:"dropdown-area"},[_c('h4',[_vm._v("Select a size")]),_vm._v(" "),_c('div',{staticClass:"dropdown",on:{"click":function($event){return _vm.onClick($event)}}},[_c('div',{staticClass:"dropdown-item selected"},[_c('span',[_vm._v(_vm._s(_vm.selectedItem.name)+" "),_c('i',[_vm._v("("+_vm._s(_vm.selectedItem.size)+")")])])]),_vm._v(" "),_vm._l((_vm.data.sizes),function(item,index){return _c('div',{staticClass:"dropdown-item",on:{"click":function($event){return _vm.onSelect(index)}}},[_c('span',[_vm._v(_vm._s(item.name)+" "),_c('i',[_vm._v("("+_vm._s(item.size)+")")])])])})],2),_vm._v(" "),_c('h2',{class:{ 'original-price' : _vm.promoPrice }},[_vm._v("$"+_vm._s(_vm.price))]),_vm._v(" "),(_vm.promoPrice)?_c('h2',{staticClass:"price"},[_vm._v("$"+_vm._s(_vm.promoPrice)+" "),_c('span',[_vm._v("with promo")])]):_vm._e(),_vm._v(" "),(_vm.promoPrice)?_c('span',{staticClass:"saves"},[_vm._v("Save $"+_vm._s(_vm.priceDiff))]):_vm._e(),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('img',{directives:[{name:"slide-up",rawName:"v-slide-up"}],staticClass:"product-image",attrs:{"src":_vm.$store.state.product.images[_vm.$route.params.product].profile}})]),_vm._v(" "),_c('transition',{attrs:{"name":'slide-from-bottom'}},[_c('reviews-component',{directives:[{name:"show",rawName:"v-show",value:(_vm.showReviews),expression:"showReviews"}],attrs:{"data":_vm.ratingData}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"featured-info"},[_c('span',[_c('img',{attrs:{"src":"/static/media/icons/warranty.png","alt":"warranty"}}),_vm._v("20 years warranty")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"/static/media/icons/nights.png","alt":"nights"}}),_vm._v("100 nights risk free trial")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_compare_component_js__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de80538_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_compare_component_html__ = __webpack_require__(140);
function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4de80538"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_compare_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de80538_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_compare_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"compare view"},[_c('back'),_vm._v(" "),_c('button-radar',{directives:[{name:"pop-in",rawName:"v-pop-in",value:(600),expression:"600"}],attrs:{"to":'/' + _vm.$route.params.product + '/our-technology',"label":'see the technology'}}),_vm._v(" "),_c('section',{staticClass:"view-wrapper is-flexy is-center is-top is-column"},[_c('h4',[_vm._v("Find the right mattress.")]),_vm._v(" "),_c('div',{staticClass:"compare-table"},[_c('div',{staticClass:"compare-table-head"},_vm._l((_vm.data),function(item){return _c('div',{staticClass:"product-col"},[_c('h2',[_vm._v(_vm._s(item.productName))]),_vm._v(" "),_c('rating-component',{attrs:{"product":item.productName}}),_vm._v(" "),_c('div',{staticClass:"firmness"},[_vm._v(_vm._s(item.firmness))])],1)}),0),_vm._v(" "),_c('div',{staticClass:"compare-table-body"},_vm._l((_vm.data),function(item){return _c('div',{staticClass:"product-col"},_vm._l((item.items),function(el){return _c('div',{class:{ 'compare-item': true, 'compare-item-large': el.boxLarge, 'compare-item-xlarge': el.boxXLarge, 'compare-item-wide': el.boxWide }},[_c('span',{domProps:{"innerHTML":_vm._s(el.key)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(el.value)}})])}),0)}),0)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_our_technology_component_js__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe54f34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_our_technology_component_html__ = __webpack_require__(143);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_our_technology_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe54f34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_our_technology_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"our-technology view"},[(_vm.videoIsFinished)?_c('back',{attrs:{"back-to":'/' + _vm.$route.params.product + '/discover'}}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"player"},on:{"click":function($event){return _vm.play()}}}),_vm._v(" "),_c('div',{staticClass:"fullscreen-bg"},[_c('video',{staticClass:"fullscreen-bg__video",attrs:{"muted":"","src":"/static/media/videos/technology_intro.webm","id":"video"},domProps:{"muted":true}})]),_vm._v(" "),_c('transition',{attrs:{"name":'fade'}},[(_vm.videoIsFinished)?_c('div',{staticClass:"heading"},[_c('h1',[_vm._v("OUR TECHNOLOGY")]),_vm._v(" "),_c('h2',[_vm._v("Press an active point on the matress to know more")])]):_vm._e()]),_vm._v(" "),(_vm.videoIsFinished)?_c('button-radar',{directives:[{name:"pop-in",rawName:"v-pop-in",value:(600),expression:"600"}],staticClass:"cover",attrs:{"to":'/' + _vm.$route.params.product + '/our-technology/cover',"label":'Cover'}},[_vm._t("default",[_c('img',{attrs:{"src":"/static/media/icons/plus.png"}})])],2):_vm._e(),_vm._v(" "),(_vm.videoIsFinished)?_c('button-radar',{directives:[{name:"pop-in",rawName:"v-pop-in",value:(900),expression:"900"}],staticClass:"bio-pur",attrs:{"to":'/' + _vm.$route.params.product + '/our-technology/biopur',"label":'Bio-Pur®'}},[_vm._t("default",[_c('img',{attrs:{"src":"/static/media/icons/plus.png"}})])],2):_vm._e(),_vm._v(" "),(_vm.videoIsFinished && _vm.$route.params.product != 'as1')?_c('button-radar',{directives:[{name:"pop-in",rawName:"v-pop-in",value:(1200),expression:"1200"}],staticClass:"smt",attrs:{"to":'/' + _vm.$route.params.product + '/our-technology/hive',"label":'Hive®'}},[_vm._t("default",[_c('img',{attrs:{"src":"/static/media/icons/plus.png"}})])],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cover_component_js__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1f48ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_cover_component_html__ = __webpack_require__(146);
function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d1f48ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cover_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1f48ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_cover_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"details view"},[(_vm.showBack)?_c('back',{attrs:{"back-to":'/' + _vm.$route.params.product + '/our-technology'}}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"player"},on:{"touchstart":function($event){return _vm.play()}}}),_vm._v(" "),_c('div',{staticClass:"fullscreen-bg"},[_c('video',{staticClass:"fullscreen-bg__video",attrs:{"id":"screensaver-video","muted":"","autoplay":"","preload":"none"},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/media/videos/cover.webm","type":"video/webm"}})])]),_vm._v(" "),_c('div',{staticClass:"details-panel",class:{ slideIn: _vm.showPanel }},[_c('div',{directives:[{name:"slide-up",rawName:"v-slide-up",value:(5500),expression:"5500"}],staticClass:"details-panel-title"},[_c('h1',[_vm._v("\n        ULTRA-SOFT &\n      ")]),_vm._v(" "),_c('h1',[_vm._v("BREATHABLE COVER")])]),_vm._v(" "),_c('p',{directives:[{name:"slide-up",rawName:"v-slide-up",value:(5800),expression:"5800"}]},[_vm._v("\n      Our lightweight mattress cover promotes airflow and prevents overheating so you can sleep cooler and say goodbye to night sweats."),_c('br'),_c('br'),_vm._v("It’s also soft-to-the-touch and removable so you can easily throw it in the wash and have your mattress feeling like new.\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_biopur_component_js__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f0cef6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_biopur_component_html__ = __webpack_require__(149);
function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f0cef6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_biopur_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f0cef6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_biopur_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"details view"},[(_vm.showBack)?_c('back',{attrs:{"back-to":'/' + _vm.$route.params.product + '/our-technology'}}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"player"},on:{"touchstart":function($event){return _vm.play()}}}),_vm._v(" "),_c('div',{staticClass:"fullscreen-bg"},[_c('video',{staticClass:"fullscreen-bg__video",attrs:{"id":"screensaver-video","muted":"","autoplay":"","preload":"none"},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/media/videos/biopur.webm","type":"video/webm"}})])]),_vm._v(" "),_c('div',{staticClass:"details-panel",class:{ slideIn: _vm.showPanel }},[_c('h1',{directives:[{name:"slide-up",rawName:"v-slide-up",value:(4650),expression:"4650"}]},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v("Foam\n\n    ")]),_vm._v(" "),_c('p',{directives:[{name:"slide-up",rawName:"v-slide-up",value:(4850),expression:"4850"}]},[_vm._v("\n      Bio-Pur® is the perfect answer to a better bed. We engineered Bio-Pur® to deliver cooling comfort, responsive support, and healthier sleep."),_c('br'),_c('br'),_vm._v("\n      Memory foam lovers say Bio-Pur® is a huge upgrade since it solves all the problems of traditional memory foam due to its plant-based, breathable, and ultra-responsive design."),_c('br'),_c('br'),_vm._v("Bio-Pur® snaps back to its original shape in seconds and you won’t have to worry about night sweats. Plus, we proudly manufacture Bio-Pur® in the USA.\n    ")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n\n        Bio-Pur\n\n        "),_c('span',[_vm._v("®")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_hive_component_js__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf0d954_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_hive_component_html__ = __webpack_require__(152);
function injectStyle (ssrContext) {
  __webpack_require__(151)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bf0d954"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_hive_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf0d954_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_hive_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"details view"},[(_vm.showBack)?_c('back',{attrs:{"back-to":'/' + _vm.$route.params.product + '/our-technology'}}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"player"},on:{"touchstart":_vm.play}}),_vm._v(" "),_c('div',{staticClass:"fullscreen-bg"},[_c('video',{staticClass:"fullscreen-bg__video",attrs:{"id":"screensaver-video","muted":"","autoplay":"","preload":"none"},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/media/videos/smt.webm","type":"video/webm"}})])]),_vm._v(" "),_c('div',{staticClass:"details-panel",class:{ slideIn: _vm.showPanel }},[_c('h1',{directives:[{name:"slide-up",rawName:"v-slide-up",value:(5500),expression:"5500"}]},[_vm._m(0),_c('br'),_vm._v("Technology")]),_vm._v(" "),_c('p',{directives:[{name:"slide-up",rawName:"v-slide-up",value:(5850),expression:"5850"}]},[_vm._v("\n      HIVE® (Harnessing Intelligent Ventilation & Energy) Technology uses hundreds of six-sided foam cores that expand and contract to provide strategic 5-zone support."),_c('br'),_c('br'),_vm._v("This layer offers extra cushion where you want it and firmness where you need it to soothe common sore spots like the shoulders and lower back, while also relieving pain-causing pressure points.\n    ")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("HIVE"),_c('span',[_vm._v("®")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(155);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/*
    App data is stored here
    Dynamic data from Firebase and Power Reviews will be GET in actions.js
    and saved here.

    [maybe we can use a persisted state plugin so we can keep the data offline?! -> see: vuex-persistedstate]
*/

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({

  state: {

    product: {

      title: "",
      model: "Queen",
      price: "",
      promo: "",
      description: "",
      hardness: "",
      sizes: {},

      images: {

        as1: {
          profile: "/static/media/images/as1-profile.png",
          side: "/static/media/images/as1-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        },

        as2: {
          profile: "/static/media/images/as2-profile.png",
          side: "/static/media/images/as2-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        },

        as3: {
          profile: "/static/media/images/as3-profile.png",
          side: "/static/media/images/as3-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        },

        as4: {
          profile: "/static/media/images/as4-profile.png",
          side: "/static/media/images/as4-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        },

        as5: {
          profile: "/static/media/images/as5-profile.png",
          side: "/static/media/images/as5-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        }

      },

      review: {

        score: '',
        votes: '',
        recommended_ratio: ''

      },

      reviews: []

    },

    compare: [{

      productName: "AS1",
      firmness: "Firm",
      review: {
        score: "5.0"
      },
      items: [{ key: "Available Versions", value: "Memory Foam" }, { key: "Sleep Style", value: "Stomach, Back" }, { key: "Profile Height", value: "10-inch" }, { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 2 inches<br>Bio-Core®: 8 inches', boxLarge: true }, { key: 'Hybrid Mattress<br>Layer Construction', value: 'N/A', boxLarge: true }, { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true }, { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' }, { key: "Fire Guard", value: "Green Guard fire sock" }, { key: "Price (Memory Foam)", value: "Queen: $899<br>King: $1199", boxWide: true }]
    }, {

      productName: "AS2",
      firmness: "Medium Firm",
      review: {
        score: "5.0"
      },
      items: [{ key: "Available Versions", value: "Memory Foam & Hybrid" }, { key: "Sleep Style", value: "Stomach, Back" }, { key: "Profile Height", value: "12-inch" }, { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 2 inches<br>Affinity with HIVE®: 3 inches<br>Bio-Core®: 7 inches', boxLarge: true }, { key: 'Hybrid Mattress<br>Layer Construction', value: 'Bio-Pur®: 2 inches<br>Affinity: 1 inch<br>Pocketed Coils: 8 inches<br>Base Foam: 1 inch', boxLarge: true }, { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Affinity & Affinity with HIVE®: 1.65-lb density, 17 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true }, { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' }, { key: "Fire Guard", value: "Green Guard fire sock" }, { key: "Price (Memory Foam/Hybrid)", value: "Queen: $999/$1299<br>King: $1299/$1599", boxWide: true }]
    }, {

      productName: "AS3",
      firmness: "Medium",
      review: {
        score: "5.0"
      },
      items: [{ key: "Available Versions", value: "Memory Foam & Hybrid" }, { key: "Sleep Style", value: "Side, Back, Combo" }, { key: "Profile Height", value: "12-inch" }, { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 3 inches<br>Affinity with HIVE®: 2 inches<br>Bio-Core®: 7 inches', boxLarge: true }, { key: 'Hybrid Mattress<br>Layer Construction', value: 'Bio-Pur®: 3 inches<br>Pocketed Coils: 8 inches<br>Base Foam: 1 inch', boxLarge: true }, { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Affinity with HIVE®: 1.65-lb density, 17 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true }, { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' }, { key: "Fire Guard", value: "Green Guard fire sock" }, { key: "Price (Memory Foam/Hybrid)", value: "Queen: $1099/$1399<br>King: $1399/$1699", boxWide: true }]
    }, {

      productName: "AS4",
      firmness: "Medium Soft",
      review: {
        score: "5.0"
      },
      items: [{ key: "Available Versions", value: "Memory Foam" }, { key: "Sleep Style", value: "Side, Back, Combo" }, { key: "Profile Height", value: "12-inch" }, { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 4 inches<br>Affinity with HIVE®: 1 inch<br>Bio-Core®: 7 inches', boxLarge: true }, { key: 'Hybrid Mattress<br>Layer Construction', value: 'N/A', boxLarge: true }, { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Affinity with HIVE®: 2.3-lb density, 17 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true }, { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' }, { key: "Fire Guard", value: "Green Guard fire sock" }, { key: "Price (Memory Foam)", value: "Queen: $1299<br>King: $1599", boxWide: true }]
    }, {

      productName: "AS5",
      firmness: "Soft",
      review: {
        score: "5.0"
      },
      items: [{ key: "Available Versions", value: "Memory Foam & Hybrid" }, { key: "Sleep Style", value: "Side, Combo" }, { key: "Profile Height", value: "14-inch" }, { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 3 inches<br>Active Flex: 2 inches<br>Affinity with HIVE®: 2 inches<br>Bio-Core®: 7 inches', boxLarge: true }, { key: 'Hybrid Mattress<br>Layer Construction', value: 'Bio-Pur®: 3 inches<br>Active Flex: 2 inches<br>Pocketed Coils: 8 inches<br>Base Foam: 1 inch', boxLarge: true }, { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Active Flex: 3.0-lb density, 15 ILD<br>Affinity with HIVE®: 1.65-lb density, 17 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true }, { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' }, { key: "Fire Guard", value: "Green Guard fire sock" }, { key: "Price (Memory Foam/Hybrid)", value: "Queen: $1699/$1999<br>King: $1999/$2299", boxWide: true }]
    }],

    technology: {

      cover: {

        title: "<div>CELLIANT<span>&reg;</span></div><br>COVER",
        content: "The Celliant cover is naturally antimicrobial and hypoallergenic, to provide a much safer sleep surface.<br><br>As you give off body heat, our fabric safely recycles this thermal energy into infrared light, using high-performance yarn made from 13 thermoreactive minerals.",
        video: "/static/media/videos/cover.mp4"

      },

      biopur: {

        title: "<div>Bio-Pur<span>&trade;</span></div><br>Foam",
        content: "Bio-Pur™ is designed to be responsive to you by relieving pressure points. The large open cell structure helps air to circulate, keeping your body temperature balanced from head to toe. When you lie down, you'll actively feel the relief.<br><br>The manufacturing process is environmentally friendly, producing zero emissions.",
        video: "/static/media/videos/biopur.mp4"

      },

      smt: {

        title: "SMT",
        content: "Surface Modification Technology (SMT) shapes precise channels into the foam, which allow air to circulate, providing a cooling effect.<br><br>The channels react to your body and create zones of superior pressure relief for pain points.",
        video: "/static/media/videos/smt.mp4"

      }

    }
  },

  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],

  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]

}));

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



// Power Reviews API
var MERCHANT_ID = 877647;
var LOCALE = "en_US";
var API_KEY = "7c4da1e0-28bd-4d6a-839e-7bced28cbe1b";

// let isOnline = navigator.onLine;

function getIsOnline() {
    return navigator.onLine;
}

/*
    Actions
    work as a service, get the data and send to the mutations.js objects
*/
var actions = {

    // GET PRODUCT DETAIL FROM CMS
    get_product_details: function get_product_details(_ref, product) {
        var commit = _ref.commit;

        if (!product) {
            console.log('no product to get details');
            return;
        }

        if (getIsOnline()) {

            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('https://amerisleep-cms.firebaseio.com/' + product + '.json').then(function (res) {
                return res.json();
            }).then(function (data) {

                // Commit data to mutation
                commit('UPDATE_PRODUCT_DETAILS', data);
            });
        } else {

            console.log('[ACTION] YOU ARE OFFLINE');
        }
    },


    // GET PRODUCT REVIEW AVERAGE FROM POWER REVIEWS API
    get_product_reviews_average: function get_product_reviews_average(_ref2, product) {
        var commit = _ref2.commit;

        if (!product) {
            console.log('no product to get reviews average');
            return;
        }
        if (getIsOnline()) {

            var PRODUCT = product.toUpperCase();

            switch (PRODUCT) {
                case 'AS1':
                    PRODUCT = 132;
                    break;
                case 'AS2':
                    PRODUCT = 128;
                    break;
                case 'AS3':
                    PRODUCT = 130;
                    break;
                case 'AS4':
                    PRODUCT = 141;
                    break;
                case 'AS5':
                    PRODUCT = 137;
                    break;
                default:
                    PRODUCT = '';
            }
            if (!PRODUCT) {
                console.log('[ERROR] INVALID PRODUCT DURING RATINGS COMMIT');
                return;
            }

            var PAGE_SIZE = 1;

            var url = "https://readservices-b2c.powerreviews.com/m/" + MERCHANT_ID + "/l/" + LOCALE + "/product/" + PRODUCT + "/reviews?paging.size=" + PAGE_SIZE + "&apikey=" + API_KEY + "&format=json";

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (res) {
                return res;
            }).then(function (data) {

                // Commit data to mutation
                commit('UPDATE_PRODUCT_REVIEW_AVERAGE', data.data);
            }).catch(function (err) {
                console.log('[ERROR] CANNOT RETRIEVE REVIEWS', err);
            });
        } else {

            console.log('[ACTION] YOU ARE OFFLINE');
        }
    },


    // GET PRODUCT REVIEWS FROM POWER REVIEWS API
    get_product_reviews: function get_product_reviews(_ref3, payload) {
        var commit = _ref3.commit;

        if (!payload) {
            console.log('no product to get details');
            return;
        }

        if (getIsOnline()) {

            var PRODUCT = payload.product.toUpperCase();

            switch (PRODUCT) {
                case 'AS1':
                    PRODUCT = 132;
                    break;
                case 'AS2':
                    PRODUCT = 128;
                    break;
                case 'AS3':
                    PRODUCT = 130;
                    break;
                case 'AS4':
                    PRODUCT = 141;
                    break;
                case 'AS5':
                    PRODUCT = 137;
                    break;
                default:
                    PRODUCT = '';
            }

            if (!PRODUCT) {
                return;
            }

            var PAGE_SIZE = 20;

            var paging = payload.page * PAGE_SIZE; // paging.from = next page * items per page

            var url = "https://readservices-b2c.powerreviews.com/m/" + MERCHANT_ID + "/l/" + LOCALE + "/product/" + PRODUCT + "/reviews?paging.size=" + PAGE_SIZE + "&paging.from=" + paging + "&apikey=" + API_KEY + "&format=json";

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (res) {
                return res;
            }).then(function (data) {

                // Commit data to mutation
                commit('UPDATE_PRODUCT_REVIEWS', data.data);
            }).catch(function (err) {
                console.log('[ERROR] CANNOT RETRIEVE REVIEWS', err);
            });
        } else {

            console.log('[ACTION] YOU ARE OFFLINE');
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);


/*
    Mutations
    the only place we can modify/update the state (store.js)
*/

var mutations = {

    // Update product details
    UPDATE_PRODUCT_DETAILS: function UPDATE_PRODUCT_DETAILS(state, obj) {
        var sizesArray = [];
        var reviewsArray = [];

        // Create sizes array by removing Firebase default Key
        for (var key in obj.sizes) {
            sizesArray.push(obj.sizes[key]);
        }

        // Create reviews array by removing Firebase default Key
        for (var i in obj.reviews) {
            reviewsArray.push(obj.reviews[i]);
        }

        // Update state
        state.product.title = obj.content.title;
        state.product.hardness = obj.content.firmness;
        state.product.description = obj.content.body;

        state.product.price = '$' + obj.content.price;
        state.product.promo = '$' + obj.content.promo;
        state.product.sizes = sizesArray;
    },


    // Update product review average
    UPDATE_PRODUCT_REVIEW_AVERAGE: function UPDATE_PRODUCT_REVIEW_AVERAGE(state, obj) {
        state.product.review.score = obj.results[0].rollup.average_rating;
        state.product.review.votes = obj.results[0].rollup.review_count;
        state.product.review.recommended_ratio = obj.results[0].rollup.recommended_ratio * 100 + '%';
    },


    // Update product reviews
    UPDATE_PRODUCT_REVIEWS: function UPDATE_PRODUCT_REVIEWS(state, obj) {
        var _state$product$review;

        (_state$product$review = state.product.reviews).push.apply(_state$product$review, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(obj.results[0].reviews));
    }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);

/*
  SLIDE  IN THE ELEMENT
  use: v-slide-in
  will make element show by slide in from the left

*/


//import {TweenMax, Cubic} from "gsap";

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('slide-in', {

  // ENTRY
  inserted: function inserted(el) {

    el.classList.add('slideIn');
    // TweenMax.to( el, 0.6, {x:0, ease: Cubic.easeOut }); //commented out as animating with TweenMax was causing lag on resourceless machines
  },


  // LEAVE
  unbind: function unbind(el, binding) {

    el.classList.remove('slideIn');
    // TweenMax.to( el, 0.3, {x:-1200, ease: Cubic.easeIn }); //commented out as animating with TweenMax was causing lag on resourceless machines
  }
}));

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(11);

/*

  SLIDE  UP THE ELEMENT
  use: v-slide-up
  will make element show by sliding up

*/




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('slide-up', {

  //Lets push the elemtn down initially
  bind: function bind(el) {

    el.style.opacity = 0;
    el.style.marginTop = '30px';
  },


  // ENTRY
  inserted: function inserted(el, binding) {

    //lets wait for the desirable delay before show the component
    setTimeout(function () {

      //animate it up
      __WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* TweenMax */].to(el, 1, {
        y: -30,
        opacity: 1,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["b" /* Power2 */].easeOut
      });
    }, binding.value);
  },


  // LEAVE
  unbind: function unbind(el) {

    //animate it down
    __WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* TweenMax */].to(el, 1, {
      y: 0,
      opacity: 0,
      ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["b" /* Power2 */].easeOut
    });
  }
}));

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(11);

/*
 SCALE UP THE ELEMENT
 use: v-pop-in
 will make the element show with a pop in effect
*/




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('pop-in', {

  //since we are scaling in UP, lets scale it dow first
  bind: function bind(el) {

    el.classList.add('scaleDown');
  },


  // ENTRY
  inserted: function inserted(el, binding) {

    //lets wait for the desireble delay before show the component
    setTimeout(function () {

      __WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* TweenMax */].to(el, 1, { scale: 1, opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["b" /* Power2 */].easeOut });
    }, binding.value);
  },


  // LEAVE
  unbind: function unbind(el) {

    __WEBPACK_IMPORTED_MODULE_1_gsap__["d" /* TweenMax */].to(el, 1, { scale: 1.3, opacity: 0, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["b" /* Power2 */].easeOut });
  }
}));

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = zoomIn;
/*
    Zoom in/out
*/

function zoomIn(vue) {

    var view = vue.$route.name;
    var screensaver = document.getElementById("screensaver");

    //if not on the screensaver view, zoom in
    if (view != 'screensaver') {

        screensaver.classList.add('zoom');

        //keep the animation by removing the background if deep routing
        if (view != 'discover') {

            screensaver.classList.add('fadeOut');
        } else {
            screensaver.classList.remove('fadeOut');
        }
    } else {

        screensaver.classList.remove('zoom');

        screensaver.classList.remove('fadeOut');
    }
}

/***/ })
],[65]);


// WEBPACK FOOTER //
// static/js/app.c36dc2b2fa974f003e9e.js